// The One Retail shell's in-page bridge - ADR-007 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/007-navigation-model-and-contribution.md
// AO runs in the shell's own document when embedded, so the bridge is a plain object on `window`
// rather than a message channel. It is absent standalone, so every call site guards the bridge
// itself: `shellBridge()?.navbar.register(...)`.

/** AO's registry key in the shell: navbar items, recents and the assistant all namespace on it. */
export const APP_KEY = 'assortment';

/**
 * The bridge capability level this build is written against, reported to the shell on install.
 * Levels are monotonic: the shell bumps its level on every addition and never removes or re-types a
 * member in place, and a shell that reports none is level 1.
 * See ADR-019 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/019-bridge-versioning.md
 */
export const PLATFORM_BRIDGE_VERSION = 1;

/**
 * The shell bridge if it offers at least `level`, else null (always null standalone). Pass the level
 * that added the feature you call, so a shell behind AO drops only that feature.
 */
export function shellBridge(level = 1) {
  const bridge = window.RETAIL_PLATFORM;
  return bridge && (bridge.version ?? 1) >= level ? bridge : null;
}
